import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ApplicationDetail from '../../shared/services/applicationDetail.service';
import { RootState } from '../../store';
import {
  fetchReportingTransactionMeta,
  fetchTatData,
  setReportingTransactionMeta,
} from '../../store/actions/reportingAndAnalyticsActions';
import { DATE_RANGE_TAT_CONFIG, REPORTING_CONSTANTS, REPORTING_TYPE_CONSTANTS, REPORT_ROUTE_MAP } from './reportingUtils/reportingAndAnalyticsConstants';
import TatReportNavigation from './reportingUtils/TatReportNavigation';
import TransactionCountGauge from './TransactionCountReport/TranasctionCountGuage';
import TransactionCountFilters from './TransactionCountReport/TransactionCountFilters';

const TransactionTatReport = (): React.ReactElement => {
  const [configuredPayers, setConfiguredPayers] = useState<any[]>([]);
  const [availableStatus, setAvailableStatus] = useState<any[]>([]);
  const [successFullMetaCall, setSuccessFullMetaCall] = useState(false);
  const { transactionReportFilters, resetBtnClicked }: any = useSelector(
    (state: RootState): any => state.reportingAndAnalytics,
  );
  const dispatch = useDispatch();
  const [refreshedInfo, setRefreshedInfo] = useState({});
  const [transactionData, setTransactionData] = useState({});
  const [sections, setSections] = useState<any[]>([]);
  const [activeSection, setActiveSection] = useState('');
  const [expandedSections, setExpandedSections] = useState<
    Record<string, boolean>
  >({});

  const getSections = (data: any): void => {
    setSections(data);
  };
  const getConfiguredPayers = (): any[] => {
    const configuredPayersList = ApplicationDetail.instance.getConfiguredPayer();
    if (configuredPayersList) {
      return (
        configuredPayersList?.reduce((acc: any[], payer: any): any[] => {
          acc?.push({ label: payer?.name, value: payer?.uniqueIdentifier });
          return acc;
        }, []) || []
      );
    }
    return [];
  };

  const getAvailableStatus = (
    tatTypeList: any[],
  ): { label: string; value: string }[] => {
    if (!tatTypeList) {
      return [];
    }

    return tatTypeList?.map((item: any): { label: string; value: string } => ({
      label: item?.tatType,
      value: String(item?.tatTypeId),
    }));
  };

  const successFullMetaCallback = (flag: boolean): void => {
    setSuccessFullMetaCall(flag);
  };
  const {
    location: { pathname },
  } = useHistory();
  const tabName = REPORT_ROUTE_MAP[pathname];
  const successCallback = (
    data: any,
    dataAvailableFrom: string,
    dataRefreshedOn: string,
    lastRefreshedOn: string,
  ): void => {
    if (
      !isEmpty(data)
    ) {
      setTransactionData(data);
      setRefreshedInfo({
        dataAvailableFrom,
        dataRefreshedOn,
        lastRefreshedOn,
      });
    } else {
      setTransactionData({});
      setRefreshedInfo({});
    }
  };
  const successMetaData = (data: any): any => {
    const { dashboardData, filters } = data;
    setAvailableStatus(getAvailableStatus(filters.TatType));
    dispatch(setReportingTransactionMeta(dashboardData));
  };

  useEffect((): void => {
    setConfiguredPayers(getConfiguredPayers());
    dispatch(
      fetchReportingTransactionMeta({
        successFullMetaCallback,
        successMetaData,
        tabName,
      }),
    );
  }, []);

  useEffect((): void => {
    setExpandedSections({});
  }, [resetBtnClicked]);

  useEffect((): void => {
    if (successFullMetaCall && !isEmpty(availableStatus)) {
      dispatch(
        fetchTatData({
          successCallback,
          configuredPayers,
          availableStatus,
        }),
      );
    }
  }, [transactionReportFilters, successFullMetaCall, availableStatus]);

  return (
    <div className="three-part-container">
      <div className="left-section hide-scrollbar">
        <TransactionCountFilters
          configuredPayers={configuredPayers}
          availableStatus={availableStatus}
          statusFilterLabel={REPORTING_CONSTANTS.TAT_TYPE}
          dateRangeConfig={DATE_RANGE_TAT_CONFIG}
        />
      </div>
      <div className="middle-section hide-scrollbar">
        <TransactionCountGauge
          getSections={getSections}
          setActiveSection={setActiveSection}
          configuredPayers={configuredPayers}
          availableStatus={availableStatus}
          transactionData={transactionData}
          reportType={REPORTING_TYPE_CONSTANTS.TRANSACTION_TAT}
          expandedSections={expandedSections}
          setExpandedSections={setExpandedSections}
        />
      </div>
      <div className="right-section hide-scrollbar">
        <TatReportNavigation
          sections={sections}
          activeSection={activeSection}
          configuredPayers={configuredPayers}
          availableStatus={availableStatus}
          refreshedInfo={refreshedInfo}
          expandedSections={expandedSections}
          setExpandedSections={setExpandedSections}
        />
      </div>
    </div>
  );
};

export default TransactionTatReport;
